const FILAMENT_KEY = 'printcalc_filaments'
const PRINTER_KEY  = 'printcalc_printers'
const HISTORY_KEY  = 'printcalc_history'
const HISTORY_LIMIT = 20

// ---------------------------------------------------------------------------
// Pro status
// ---------------------------------------------------------------------------

export const isPro = () => localStorage.getItem('printcalc_pro') === 'true'
export const activatePro = () => localStorage.setItem('printcalc_pro', 'true')
export const deactivatePro = () => localStorage.removeItem('printcalc_pro')

// ---------------------------------------------------------------------------
// Generic helpers
// ---------------------------------------------------------------------------

function load(key) {
  try {
    return JSON.parse(localStorage.getItem(key)) ?? []
  } catch {
    return []
  }
}

function save(key, data) {
  localStorage.setItem(key, JSON.stringify(data))
}

// ---------------------------------------------------------------------------
// Filament presets
// ---------------------------------------------------------------------------

export function getFilamentPresets() {
  return load(FILAMENT_KEY)
}

export function saveFilamentPreset(preset) {
  if (!isPro()) return { ok: false, reason: 'pro_required' }
  const list = getFilamentPresets()
  const entry = {
    ...preset,
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
  }
  list.unshift(entry)
  save(FILAMENT_KEY, list)
  return { ok: true, entry }
}

export function deleteFilamentPreset(id) {
  const list = getFilamentPresets().filter(p => p.id !== id)
  save(FILAMENT_KEY, list)
}

// ---------------------------------------------------------------------------
// Printer profiles
// ---------------------------------------------------------------------------

export function getPrinterProfiles() {
  return load(PRINTER_KEY)
}

export function savePrinterProfile(profile) {
  if (!isPro()) return { ok: false, reason: 'pro_required' }
  const list = getPrinterProfiles()
  const entry = {
    ...profile,
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
  }
  list.unshift(entry)
  save(PRINTER_KEY, list)
  return { ok: true, entry }
}

export function deletePrinterProfile(id) {
  const list = getPrinterProfiles().filter(p => p.id !== id)
  save(PRINTER_KEY, list)
}

// ---------------------------------------------------------------------------
// Quote history
// ---------------------------------------------------------------------------

export function getHistory() {
  return load(HISTORY_KEY)
}

export function saveToHistory(label, inputs, result) {
  if (!isPro()) return { ok: false, reason: 'pro_required' }
  const list = getHistory()
  const entry = {
    id: crypto.randomUUID(),
    label: label || 'Untitled job',
    inputs,
    result,
    savedAt: new Date().toISOString(),
  }
  list.unshift(entry)
  save(HISTORY_KEY, list.slice(0, HISTORY_LIMIT))
  return { ok: true, entry }
}

export function deleteHistoryEntry(id) {
  const list = getHistory().filter(e => e.id !== id)
  save(HISTORY_KEY, list)
}